import React from 'react';
import { Logo } from '../../../svg';

const WhatsappHome = () => {
    return (
        <div className='h-full w-full dark:bg-dark_bg_4 select-none border-s-2 dark:border-s-dark_border_2 border-b-[6px] border-b-green_2'>

            <div className='mt-1.5 w-full h-full flex flex-col gap-y-8 items-center justify-center'>
                <span><Logo/></span>
                <div className='mt-1 text-center space-y-[12px] px-4'>
                    <h1 className="text-2xl sm:text-[32px] dark:text-dark_text_4 font-extralight">
                        تجارة +
                    </h1>
                    <p className='text-sm dark:text-dark_text_3'>
                        منصة <strong>تجارة إلكترونية</strong> مدعومة بالذكاء الاصطناعي<br/>
                        لإدارة المحادثات والمبيعات بكفاءة.
                    </p>
                </div>
            </div>

        </div>
    );
}

export default WhatsappHome;
